var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelSolidButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "4 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#______src_modules_popup_svg_CancelSolidButton_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#______src_modules_popup_svg_CancelSolidButton_svg__b)",
    fillOpacity: 0.85,
    d: "M4 50.5C4 22.886 26.386.5 54 .5s50 22.386 50 50-22.386 50-50 50-50-22.386-50-50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#______src_modules_popup_svg_CancelSolidButton_svg__c)",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    d: "M5 50.5c0-27.062 21.938-49 49-49s49 21.938 49 49-21.938 49-49 49-49-21.938-49-49Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.214 64.296 57.568 49.65l14.25-14.25c1.23-1.229 1.23-3.208 0-4.416-1.23-1.23-3.208-1.23-4.417 0l-14.25 14.25-14.646-14.646c-1.229-1.23-3.208-1.23-4.416 0-1.23 1.23-1.23 3.208 0 4.417L48.735 49.65 34.485 63.9c-1.23 1.23-1.23 3.209 0 4.417a3.14 3.14 0 0 0 2.208.917c.792 0 1.604-.313 2.208-.917l14.25-14.25 14.646 14.646a3.14 3.14 0 0 0 2.209.917c.791 0 1.604-.313 2.208-.917 1.229-1.23 1.229-3.208 0-4.417"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_popup_svg_CancelSolidButton_svg__b",
    x1: 4,
    x2: 104,
    y1: 0.5,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12110F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_popup_svg_CancelSolidButton_svg__c",
    x1: 54,
    x2: 54,
    y1: 0.5,
    y2: 100.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "______src_modules_popup_svg_CancelSolidButton_svg__a",
    width: 108,
    height: 108,
    x: 0,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6524_250022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6524_250022",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSolidButton);
export default __webpack_public_path__ + "static/media/CancelSolidButton.c8771cb94e3932a0fc607393bc177f0b.svg";
export { ForwardRef as ReactComponent };